module.exports = __webpack_public_path__ + "static/media/Email Template.f0ca683f.png";